import { useState, useEffect } from 'react';

export const useLinkedInAccount = () => {
  const [accountId, setAccountId] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadAccount = () => {
    const savedAccountId = localStorage.getItem('selectedLinkedInAccountId');
    const savedAccountType = localStorage.getItem('selectedAccountType');
    
    setAccountId(savedAccountId ? parseInt(savedAccountId) : null);
    setAccountType(savedAccountType || 'personal');
    setLoading(false);
  };

  useEffect(() => {
    loadAccount();

    // Listen for account changes
    const handleAccountChange = () => {
      loadAccount();
    };

    window.addEventListener('accountChanged', handleAccountChange);
    return () => window.removeEventListener('accountChanged', handleAccountChange);
  }, []);

  return { accountId, accountType, loading };
};